import React from 'react';
import styled from 'styled-components';

import { TextArea } from 'wg-fe-ui';
import { Change } from '../../../../../types/Form';
import { customScrollBar } from '../../../../common/src/utils/styledComponentsUtils';

interface Props {
  name: string;
  error?: string;
  value: string;
  placeholder: string;
  onChange: (arg0: string) => void;
  onBlur: () => void;
}

const SelectedOfferTextArea: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  value,
  error,
  placeholder,
  onChange,
  onBlur,
}) => {
  return (
    <StyledTextArea
      error={error}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={(e: Change) => onChange((e.value as string)?.toString() || '')}
      onBlur={onBlur}
    />
  );
};

const StyledTextArea = styled(TextArea)`
  label {
    display: none;
  }
  textarea {
    font-family: Circular, sans-serif;
    font-size: 1.4rem;
    line-height: 120%;
    resize: none;
    &::placeholder {
      color: ${({ theme }) => theme.gray[200]};
    }
    ${customScrollBar}

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.primary[500]};
      transition: 0.1s;
    }
  }
`;

export default SelectedOfferTextArea;
